function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 10.5l-.001-1v0c0-1.082 0-1.622-.113-2.087a4 4 0 00-2.283-2.721c-.438-.192-.97-.286-2.036-.474L6.501 2.794c-1.515-.267-2.272-.4-2.817-.169a2 2 0 00-1.06 1.06c-.232.545-.098 1.302.17 2.817l1.272 7.21c.332 1.88.497 2.82.973 3.525a4 4 0 001.689 1.417c.777.346 1.731.346 3.64.346h.98c.978 0 1.467 0 1.928-.11.408-.099.798-.26 1.156-.48.404-.247.75-.593 1.441-1.285L19.5 13.5a1.414 1.414 0 012 0v0a1.414 1.414 0 010 2l-5.5 5.5M3.499 3.5l4 4M13 11a2 2 0 11-4 0 2 2 0 014 0z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIdea = function SvgIdea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#D8DAE7"
  }, props), _ref);
};

export default SvgIdea;